import React from 'react';
import { Href } from './Href';
export var Tag = function (_a) {
    var tag = _a.tag;
    var name = "#" + tag.name();
    var description = tag.description() || '';
    var externalDocs = tag.externalDocs();
    var element = (React.createElement("div", { title: description, className: "border border-solid border-blue-300 hover:bg-blue-300 hover:text-blue-600 text-blue-500 font-bold no-underline text-xs rounded px-3 py-1" },
        React.createElement("span", { className: externalDocs ? 'underline' : '' }, name)));
    if (externalDocs) {
        return (React.createElement(Href, { href: externalDocs.url(), title: description }, element));
    }
    return element;
};
//# sourceMappingURL=Tag.js.map